import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ModalPartidasActivas from "@/components/Commons/ModalPartidasActivas.vue";
import { getPartidasTorneoPorFechaAsync } from "@/services/PartidaTorneoService";
// Estado para el modal y las partidas activas
import { ref, computed, onMounted, watch } from "vue";
import { useAuth } from "@/composables/useAuth";
import { useRouter } from "vue-router";
import LogoutDialog from "@/components/Commons/LogoutDialog.vue";
import LogoAmonSulPNG from "@/assets/icons/Logo2.png";
import LogoAmonSulSVG from "@/assets/icons/logo_horizontal3.png";
import FooterComponent from "@/components/Commons/FooterComponent.vue";
import { useUsuariosStore } from "@/store/usuarios";
import { UsuarioViewDTO } from "@/interfaces/Usuario";
import defaultAvatar from "@/assets/icons/perfil.png";
import { useToast } from "@/composables/useToast";
import { useDeepLinks } from "@/composables/useDeepLinks";
import { useBotonAtras } from "@/composables/useBotonAtras";
import { EstaJugandoDTO } from "./interfaces/Partidas";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const mostrarModalPartidas = ref<boolean>(false);

const usuariosStore = useUsuariosStore();
// El del store: si el perfil cambia el avatar, la barra lo ve al momento
const user = computed<UsuarioViewDTO>(() => usuariosStore.usuario ?? ({} as UsuarioViewDTO));
const { showToast, toastMessage, toastColor } = useToast();

const { logout, getUser, getidUsuario } = useAuth();
const router = useRouter();
const drawer = ref(false);
const mostrarDialogoLogout = ref(false);
const { isAuthenticated } = useAuth();
const estaJugando = ref<EstaJugandoDTO>();

const isLoggedIn = computed(() => !!getUser.value);

const handleLogout = async () => {
  usuariosStore.usuario = {} as UsuarioViewDTO; // Limpia los datos del usuario anterior
  logout();
  router.push({ name: "inicio-sesion" });
};

// Función para cargar los datos del usuario
const cargarUsuario = async () => {
  try {
    await usuariosStore.requestUsuario(getUser.value);
  } catch (error) {
    console.error("Error al obtener el usuario:", error);
  }
};

watch(
  () => getUser.value,
  nuevoUsuario => {
    if (nuevoUsuario) {
      cargarUsuario();
    } else {
      usuariosStore.usuario = {} as UsuarioViewDTO;
    }
  },
  { immediate: true }
);

// Llamada real al backend para comprobar partidas activas
const comprobarPartidasActivas = async (idUsuario: string) => {
  try {
    const response = await getPartidasTorneoPorFechaAsync(Number(idUsuario));

    if (response.status === 200) {
      estaJugando.value = response.data;
      if (estaJugando.value?.tienePartidas) {
        mostrarModalPartidas.value = true;
      }
    }
  } catch (error) {
    console.error("Error al comprobar partidas activas:", error);
  }
};

onMounted(() => {
  useDeepLinks().init();
  useBotonAtras().init();

  // Sin sesión no se pregunta: el servidor diría 401 y mandaría a iniciar sesión desde las páginas
  // que no la necesitan, como la de elegir una contraseña nueva o la de registro
  if (isLoggedIn.value) {
    cargarUsuario();
    comprobarPartidasActivas(getidUsuario.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        (_unref(isAuthenticated))
          ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
              key: 0,
              modelValue: drawer.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
              app: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (drawer.value = false), ["stop"])),
                  class: "close-drawer-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_list, { class: "ringbearer" }, {
                  default: _withCtx(() => [
                    (_unref(isAuthenticated))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          link: "",
                          to: "/home"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Home")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(isAuthenticated))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 1,
                          link: "",
                          to: `/detalle-jugador/${_unref(getidUsuario)}`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Ficha de jugador")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    (_unref(isAuthenticated))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 2,
                          link: "",
                          to: "/mis-torneos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Mis eventos")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(isAuthenticated))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 3,
                          link: "",
                          to: "/torneos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Calendario de eventos")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(isAuthenticated))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 4,
                          link: "",
                          to: "/jugadores"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Usuarios")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(isAuthenticated))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 5,
                          link: "",
                          to: "/elo"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("ELO")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(isAuthenticated))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 6,
                          link: "",
                          to: "/gestion-eventos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Gestión Eventos")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(isAuthenticated))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 7,
                          link: "",
                          to: "/circuitos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Circuitos")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(isAuthenticated))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 8,
                          link: "",
                          to: "/estadisticas-ejercito"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Estadísticas")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(isAuthenticated))
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 9,
                          link: "",
                          to: "/perfil-usuario"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Perfil")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_app_bar, { app: "" }, {
          default: _withCtx(() => [
            (_unref(isAuthenticated))
              ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (drawer.value = !drawer.value), ["stop"]))
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_app_bar_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  src: _unref(LogoAmonSulSVG),
                  alt: "Icono personalizado",
                  height: "30"
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              icon: "",
              to: "contacto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-email")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(isAuthenticated))
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  icon: "",
                  onClick: _cache[3] || (_cache[3] = () => _unref(router).push({ name: 'perfil-usuario' }))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_avatar, {
                      size: "30",
                      class: "avatar"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: user.value.imagen || _unref(defaultAvatar),
                          alt: "Avatar"
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(isAuthenticated))
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 2,
                  icon: "",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (mostrarDialogoLogout.value = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-logout")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(LogoutDialog, {
          isVisible: mostrarDialogoLogout.value,
          titulo: "Cerrar sesión",
          mensaje: "¿Estás seguro de que deseas cerrar sesión?",
          textoConfirmar: "Sí",
          textoCancelar: "No",
          "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (mostrarDialogoLogout.value = $event)),
          onConfirmar: handleLogout,
          onCancelar: _cache[6] || (_cache[6] = ($event: any) => (mostrarDialogoLogout.value = false))
        }, null, 8, ["isVisible"]),
        _createVNode(FooterComponent, { absolute: "true" }),
        _createVNode(ModalPartidasActivas, {
          modelValue: mostrarModalPartidas.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((mostrarModalPartidas).value = $event)),
          estaJugando: estaJugando.value,
          idUsuario: Number(_unref(getidUsuario))
        }, null, 8, ["modelValue", "estaJugando", "idUsuario"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _unref(showToast),
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(showToast) ? (showToast).value = $event : null)),
      color: _unref(toastColor),
      timeout: "3000",
      top: "",
      right: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(toastMessage)), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ], 64))
}
}

})